export const initGA = () => {
  const GA_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

  if (!GA_ID) {
    console.warn("Google Analytics ID is missing.");
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = gtag;

  script.onload = () => {
    gtag("js", new Date());
    gtag("config", GA_ID);
  };
};
